import { render } from "./Pengaduan.vue?vue&type=template&id=c9732866"
import script from "./Pengaduan.vue?vue&type=script&lang=js"
export * from "./Pengaduan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__